module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Playade-Patos-293e9e731cc53080f25f35b2a7ced429.jpg";